import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef, useId } from 'react';

// Source: images/duplicate-applicant-icon-grey.svg; the white separator is omitted.
// The badge's white rectangles become cutouts so they reveal any background.
export const DuplicateApplicantHistoryIcon = forwardRef<
  SVGSVGElement,
  BaseIconProps
>(function DuplicateApplicantHistoryIcon(props, ref) {
  const clipId = useId();
  return (
    <BaseIcon
      ref={ref}
      viewBox="0 0 16 16"
      fill="currentColor"
      stroke="none"
      {...props}
    >
      <defs>
        <clipPath id={clipId}>
          <path
            clipRule="evenodd"
            d="M0 0H16V16H0Z M11 12V9H12V12Z M11 14V13H12V14Z"
          />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <path d="M6 6C7.65685 6 9 4.65685 9 3C9 1.34315 7.65685 0 6 0C4.34315 0 3 1.34315 3 3C3 4.65685 4.34315 6 6 6Z" />
        <path d="M12 11.254C12 10.348 11.6467 9.4855 11.016 8.923C10.052 8.062 8.38 7 6 7C3.62 7 1.948 8.062 0.984 8.923C0.353333 9.4855 0 10.348 0 11.254V13H12V11.254Z" />
        <circle cx="11.5" cy="11.5" r="5" />
      </g>
    </BaseIcon>
  );
});
